import * as React from 'react';

import { OAPClasses } from './OAPClasses';
import { SelectBoxOption } from '../../../stores/SelectBoxStore';
import { BasePopupMenuIcon } from '../BasePopupMenuIcon';
import { OAPActions } from '../../../actions/OAPActions';
import { BasePopupMenuTitleSetting } from '../BasePopupMenuHeader';
import { OAPLevel } from '../../../stores/OAPStore';
import { BasePopupMenuContent } from '../BasePopupMenuContent';

import core = egr.wcf.core;
import utils = egr.wcf.utils;
import { GlobalHelper } from '../../../utils/GlobalHelper';

export class OAPProperties extends OAPClasses {
    public render(): JSX.Element {
        // 2nd level
        return (
            <BasePopupMenuContent
                transform={true}
                defaultValue={null}
                flagPosition={this.props.position.flagPosition}
                open={this.props.showEditor}
                options={this.options()}
                title={this.title()}
            />
        );
    }

    protected classFilter = (value: core.prop.Property): boolean => {
        return (
            this.props.selectedClass == null ||
            utils.string.isNullOrEmpty(this.props.selectedClass.key) ||
            (value.class === this.props.selectedClass.key)
        );
    };

    protected options = (): Array<SelectBoxOption> => {
        if (this.props.properties != null && this.props.properties.length > 0) {
            return this.props.properties.filter(this.classFilter).map((value, index) => {
                let className: string = '';
                let icon: JSX.Element | null = null;

                const propertyValue = value.getValue();

                if (propertyValue != null && !utils.string.isNullOrEmpty(propertyValue.largeIcon)) {
                    icon = <BasePopupMenuIcon src={propertyValue.largeIcon} key="icon"/>;
                } else if (propertyValue != null && !utils.string.isNullOrEmpty(propertyValue.smallIcon)) {
                    icon = <BasePopupMenuIcon src={propertyValue.smallIcon} key="icon"/>;
                } else {
                    className = ' egr-select-option-no-icon';
                }

                const extraButtons: Array<JSX.Element> = [];

                if (icon != null) {
                    extraButtons.push(icon);
                }
                if (!value.editable) {
                    return {
                        name: OAPActions.getName(value),
                        key: index + '-o',
                        className: 'egr-select-disabled' + className,
                        extraButtons: extraButtons.concat([<span key="label">&nbsp;{value.getValueAsString()}</span>])
                    };
                }

                let valueText = propertyValue == null ? null : propertyValue.text;

                if (valueText == null && value.type === core.prop.PropertyType.Length && propertyValue != null) {
                    valueText = GlobalHelper.getLocaleLengthString(propertyValue.value as number);
                } else if (valueText == null || valueText === '') {
                    valueText = value.getValueAsString();
                }

                return {
                    name: OAPActions.getName(value),
                    key: index + '-o',
                    className: 'egr-select-option-arrow' + className,
                    callback: () => {
                        OAPActions.setSelectedProperty(value);
                    },
                    extraButtons: extraButtons.concat([<span key="label"style={{color: '#95c11f'}}>&nbsp;{valueText}</span>])
                };
            });
        }

        return [];
    };

    protected title = (): BasePopupMenuTitleSetting => {
        if (utils.string.isNullOrEmpty(this.props.title)) {
            return {label: ''};
        }

        if (this.props.startLevel < OAPLevel.Properties) {
            return {label: this.props.title, className: 'egr-select-option-header-back', callback: () => {
                OAPActions.setSelectedClass(null);
            }};
        }

        return {label: this.props.title, className: '', callback: () => {
            OAPActions.hideDialog();
        }};
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/OAP/OAPProperties.tsx